export const adsterraConfig = {
  bannerHost: "www.highperformanceformat.com",
  banners: {
    "300x250": {
      key: "d3e792c4fefc7076fa1cdda6fa7867d4",
      scriptSrc: ""
    },
    "728x90": {
      key: "ad9a10c8f0c75101f4d6814d2b080841",
      scriptSrc: ""
    },
    "320x50": {
      key: "1b8379fbfb4119e5a51065f957e34dee",
      scriptSrc: ""
    },
    "468x60": {
      key: "1709a6e11a0b3c114520448b78867ad3",
      scriptSrc: ""
    },
    "160x300": {
      key: "10d686485357eb5179aa1d7c49020b2e",
      scriptSrc: ""
    },
    "160x600": {
      key: "82eeabeb6795425c6dfd086fb886bbe5",
      scriptSrc: ""
    }
  },
  native: {
    key: "",
    host: "",
    scriptSrc: "https://pl29723237.effectivecpmnetwork.com/c956bfe371552231a74f5e5c7811f315/invoke.js",
    containerId: "container-c956bfe371552231a74f5e5c7811f315"
  },
  popunder: {
    key: "",
    host: "",
    scriptSrc: "https://pl29723236.effectivecpmnetwork.com/09/ea/fb/09eafbd43344ef081ff43d81ac9766d8.js"
  }
};
